import { Injectable } from '@angular/core';
import { IAttachmentDownloadRequest } from '@g99-product-web-ui/shared-interface-lib';
import { Observable } from 'rxjs';

import { fileExtensions } from './attachment.service.constant';
import { HttpService } from '../../core/http-service/http.service';

/**
 * Service for handling file attachments such as downloading files as blobs and triggering downloads.
 */
@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  constructor(
    private _http: HttpService // HTTP service to manage HTTP requests
  ) {}

  /**
   * Retrieves attachment data and triggers the download of the file as a Blob.
   *
   * @param apiUrl The API URL to send the POST request to.
   * @param requestBody The body of the POST request containing necessary data.
   * @returns An observable that emits a Blob containing the file data.
   */
  public getAttachment(
    apiUrl: string,
    requestBody: IAttachmentDownloadRequest
  ): Observable<Blob> {
    return this._http.post(apiUrl, requestBody, {
      responseType: 'blob',
      attachTenantId: true,
    });
  }

  /**
   * Downloads the file from the Blob object by creating an invisible anchor element and simulating a click.
   *
   * @param fileBlob The Blob object containing the file data.
   * @param fileName The desired name of the downloaded file.
   * @param fileExtension The file type extension (e.g., 'pdf', 'xlsx').
   */
  public downloadAttachment(
    fileBlob: Blob,
    fileName: string,
    fileExtension: string
  ): void {
    const extension = fileExtensions[fileExtension] || `.${fileExtension}`;
    fileName = fileName.endsWith(extension)
      ? fileName
      : `${fileName}${extension}`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(fileBlob);
    link.download = fileName;
    link.click();
  }
}
